import { Menu, MenuItem, Divider } from "@mui/material";
import React, { useState } from "react";
import { TIconNames } from "src/shared/types/iconNames";
import { IIconButtonProps } from "../../buttons/IconButton";
import { IconButton } from "../../index";
import { IconComponent } from "../../index";
import { IMenuItem } from "../model/types";

interface IMenuComponentProps<T = Record<string, unknown>>
  extends Omit<IIconButtonProps, "iconName"> {
  iconName?: TIconNames;
  id: string;
  menuItems: IMenuItem[] | ((row?: T) => IMenuItem[]);
  row?: T;
  isPrimaryColor?: boolean;
}

export function MenuComponent<T>({
  menuItems,
  id,
  iconName = "more-Horiz",
  row,
  isPrimaryColor,
  ...iconButtonProps
}: IMenuComponentProps<T>): JSX.Element | null {
  const [menuAnchorEl, setMenuAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(menuAnchorEl);
  const items = typeof menuItems === "function" ? menuItems(row) : menuItems;

  const handleMenuOpen = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    setMenuAnchorEl(event.currentTarget);
  };
  const handleMenuClose = (
    event: React.MouseEvent<HTMLLIElement, MouseEvent>,
  ) => {
    event.stopPropagation();
    setMenuAnchorEl(null);
  };

  if (items.length === 0) {
    return null;
  }

  const getDivider = (key: string) => {
    return (
      <Divider
        variant="middle"
        component="li"
        sx={{ mx: 3, borderColor: (theme) => theme.palette.grey[300] }}
        key={key}
      />
    );
  };

  return (
    <>
      <IconButton
        id={`action-btn${id}`}
        aria-controls={open ? `action-menu${id}` : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        color={isPrimaryColor ? "primary" : "secondary"}
        onClick={handleMenuOpen}
        iconName={iconName}
        {...iconButtonProps}
      />
      <Menu
        id="edit-menu"
        anchorEl={menuAnchorEl}
        open={open}
        onClose={handleMenuClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        {items.map(
          ({
            title,
            component,
            onClick,
            iconName: icon,
            disabled,
            dividedBottom,
            dividedTop,
          }) => [
            ...(dividedTop ? [getDivider(`${title}-divided-top`)] : []),
            <MenuItem
              disabled={disabled}
              onClick={(event) => {
                if (onClick) {
                  onClick();
                }
                handleMenuClose(event);
              }}
              key={title}
            >
              {!!icon && <IconComponent iconname={icon} />}
              {title}
              {component}
            </MenuItem>,
            ...(dividedBottom ? [getDivider(`${title}-divided-bottom`)] : []),
          ],
        )}
      </Menu>
    </>
  );
}
